module.exports = __webpack_public_path__ + "img/approveClean.1f3fb89f.svg";